module.exports = __webpack_public_path__ + "static/media/aboutvideo.aa9ddf6a.png";